module.exports = __webpack_public_path__ + "img/ANTENNA WAVES GREEN.0bfa7f6.svg";